export enum EntityType {
	Application = 'application',
	DataSource = 'data-source',
	Metric = 'metric',
	Service = 'service',
	Sla = 'sla',
}
